import React from "react";
import { Row } from "reactstrap";
export default function RowNoMargin({children,...props }) {
   
    return (
        <Row className="row-no-margin" {...props}>
            {
                React.Children.map(children, (child: React.ReactElement) => {
                    // Do something with each child
                    return React.cloneElement(child, {/* modified props */ });
                })
            }
        </Row>
        
    );
}